import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "custom-tree-node" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Cates',
  setup(__props) {

  const router = useRouter()
  const propss = {
    expandTrigger: 'hover' as const,
    value:'ID',
    label:'Title',
    children:'Children',
  }
  const searchForm = reactive({
    words:"",
    limit:1000,
    page:1,
  })
  const baseData:any = reactive({
    loading:false,
    userbox:false,
    datalist:[],
    catesbox:false,
    title:'新建分类',
  })
  const formData = reactive({
    catagory_name:'',
    parentid:'',
    catagoryid:'',
    img:'',
    sort:'',
  })
  const showCatesBox = () => {
    baseData.catesbox = true
    baseData.title = '新建分类'
    formData.catagory_name = ''
    formData.parentid = ''
    formData.catagoryid = ''
    formData.img = ''
    formData.sort = ''
  }
  const showEidtCatesBox = (data:any) => {
    baseData.catesbox = true
    baseData.title = '编辑分类'
    formData.catagory_name = data.title
    formData.parentid = data.parentid ? data.parentid : ''
    formData.catagoryid = data.id
    formData.img = data.img
    formData.sort = data.sort
  }
  const handleChange = (value:any) => {
    formData.parentid = value[value.length-1]
  }
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          formData.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const save = () => {
    baseData.loading = true
    if(formData.catagoryid){
      api.companyApi.edit_cate(formData).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.catesbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.companyApi.add_cate(formData).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.catesbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const del_cate = (id:number) => {
    api.companyApi.del_cate({catagoryid:id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.datalist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (catagoryid:string) =>{
    api.companyApi.changeStatus({catagoryid:catagoryid}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      getList()
    })
  }
  const defaultProps = {
    children: 'children',
    label: 'title',
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("分类列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: showCatesBox,
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加分类")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tree, {
          ref: "treeRef",
          class: "filter-tree",
          "expand-on-click-node": false,
          data: baseData.datalist,
          props: defaultProps,
          "default-expand-all": ""
        }, {
          default: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(data.title), 1),
              _createElementVNode("span", null, [
                _createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: ($event: any) => (showEidtCatesBox(data)),
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (del_cate(data.id)),
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.catesbox,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((baseData.catesbox) = $event)),
      title: baseData.title
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (baseData.catesbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: formData,
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "分类名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.catagory_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.catagory_name) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上级分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: formData.parentid,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.parentid) = $event)),
                  options: baseData.datalist,
                  props: propss,
                  "show-all-levels": false,
                  filterable: "",
                  clearable: "",
                  onChange: handleChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "图标" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "martop" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: "avatar-uploader",
                      action: "",
                      "http-request": uploadImg,
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        (formData.img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: formData.img,
                              class: "avatar"
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})